import { FC } from 'react';
import { SiPayModal } from 'utilities/components';
import { Button } from '30pay/components';
import { PopUp } from 'interfaces';
import { resolvePopUpImageUrl } from './popupManager.script';

interface Props {
    isOpen: boolean;
    popup: PopUp;
    onClose: () => void;
    onLink: (linkTo: string) => void;
}

const PopupModal: FC<Props> = ({ isOpen, popup, onClose, onLink }) => {
    const imageSrc = resolvePopUpImageUrl(popup.imageUrl);
    const { title, description, linkTo } = popup;

    return (
        <SiPayModal isOpen={isOpen} onClose={onClose} maxWidth={480} disableCloseIcon>
            <div className="flex w-full flex-col items-center text-center">
                {imageSrc && (
                    <img src={imageSrc} alt={title} className="mb-4 w-full rounded-xl object-contain" />
                )}
                {title && <h4 className="text-black-100 text-xl font-medium">{title}</h4>}
                {description && (
                    <p className="text-black-100 mt-2 whitespace-pre-line text-sm leading-6">{description}</p>
                )}
                <div className="mt-6 flex w-full items-center gap-4">
                    {linkTo && (
                        <Button type="primary" className="w-full" onClick={() => onLink(linkTo)}>
                            مشاهده
                        </Button>
                    )}
                    <Button type={linkTo ? 'default' : 'primary'} className="w-full" onClick={onClose}>
                        متوجه شدم
                    </Button>
                </div>
            </div>
        </SiPayModal>
    );
};

export default PopupModal;
